<template>
  <div v-if="listDatasReady">
    <div class="set-share-box clearfix">
      <div class="left fl">
        <h3 class="title">
          {{ $t('message[1767]') }}
        </h3>
        <p class="fs-gray666">
          {{ $t('message[1768]') }}
        </p>
      </div>
      <div class="right">
        <a-switch
          :checked="isShare"
          @change="onChangeSwitch"
        />
        <!-- 已开启/已关闭 -->
        {{ isShare ? $t('message[1466]') : $t('message[1459]') }}
      </div>
    </div>
    <div class="allocation-op-box clearfix">
      <div class="rule-add-box">
        <a-form
          :form="form"
          layout="inline"
          @submit.prevent="saveForm"
        >
          <a-form-item :label="groupTit">
            <a-cascader
              v-if="currentDevelopDatas.length"
              v-decorator="['value']"
              :options="currentDevelopDatas"
              change-on-select
              class="dev-choose-list"
              :placeholder="selectGroupPlace"
              @change="onChange"
            />
          </a-form-item>
          <a-form-item>
            <a-button
              type="primary"
              html-type="submit"
            >
              {{ $t('message["91"]') }}
            </a-button>
            <a-button
              @click="getDefault"
            >
              {{ $t('message["1625"]') }}
            </a-button>
          </a-form-item>
        </a-form>
      </div>
    </div>
    <div class="allocation-table-list2">
      <table-list
        :columns="columns"
        :data="wayLists"
      />
    </div>
  </div>
</template>
<script>
import TableList from './TableList'
import { mapState, mapActions, mapGetters } from 'vuex'
export default {
  components: {
    TableList
  },
  provide () {
    return {
      myForm: this.form
    }
  },
  inject: ['reload'],
  data () {
    return {
      form: this.$form.createForm(this),
      filterData: {},
      isShare: false
    }
  },
  computed: {
    ...mapState(['baseinfo']),
    ...mapState('config/allocationrule', ['listDatasReady', 'teamData', 'activeName']),
    ...mapGetters('config/allocationrule', ['wayLists', 'currentDevelopDatas']),
    columns () {
      return [{
        dataIndex: 'rolename',
        key: 'rolename',
        title: this.$t('message["374"]')
      }, {
        title: this.$t('message["1332"]'),
        dataIndex: 'groupname',
        key: 'groupname'
      },
      {
        title: this.$t('message["300"]'),
        dataIndex: 'divide_typeStr',
        key: 'divide_typeStr',
        scopedSlots: { customRender: 'method' }
      },
      {
        title: this.$t('message["79"]'),
        key: 'id',
        dadaIndex: 'id',
        scopedSlots: { customRender: 'setmethodid' }
      }]
    },
    argQuery () {
      return this.$route.query
    },
    selectGroupPlace () {
      return this.$t('message["885"]')
    },
    groupTit () {
      return this.$t('message["1332"]')
    },
    enableshare () {
      const { enableshare } = this.baseinfo || {}
      return enableshare
    }
  },
  watch: {
    activeName (val) {
      if (val) {
        this.form.resetFields()
      }
    },
    $route (to, from) {
      console.log(12)
    }
  },
  async created () {
    await this.getAuthTeamInfo()
    // const arr = Object.keys(this.argQuery)
    if (Object.keys(this.argQuery).length) {
      const chain = await this.fetchAllocationListDatas()
      chain.params({ roleid: this.argQuery.roleid, groupid: this.argQuery.groupid })
        .onSuccess(raw => {
          // this.$route.query = {}
          this.form.setFieldsValue({ value: [this.argQuery.roleid + 'roleid', this.argQuery.groupid + 'groupid'] })
          this.filterData = { roleid: this.argQuery.roleid, groupid: this.argQuery.groupid }
        })
        .fetch()
    }
    // 是否共享
    this.isShare = this.enableshare === 1
  },
  methods: {
    ...mapActions(['permissionMenu']),
    ...mapActions('config/allocationrule', [
      'getAuthTeamInfo',
      'fetchAllocationListDatas',
      'setIsShare'
    ]),
    saveForm () {
      this.form.validateFieldsAndScroll(async (err, values) => {
        if (!err) {
          const chain = await this.fetchAllocationListDatas()
          chain.params(this.filterData)
            .fetch()
        }
      })
    },
    async getDefault () {
      // this.data.info = {}
      this.form.resetFields()
      this.$router.push({ name: 'configRule', query: { tab: 'setmethod' } })
      const chain = await this.fetchAllocationListDatas()
      chain.fetch()
    },
    onChange (val, n) {
      let obj = {}
      let newObj = {}
      if (val.length) {
        n.forEach((item) => {
          const key = item.keyname
          newObj[key] = item.id
          obj = Object.assign(obj, newObj)
        })
      }
      this.filterData = obj
    },
    async onChangeSwitch (checked) {
      let chain = await this.setIsShare(checked)
      chain.onSuccess((payload = {}) => {
        if (!checked && payload.shareNum > 0) {
          this.$confirm({
            title: this.$t('message[1770]'), // 关闭失败
            content: this.$t('message[1769]'),
            closable: true,
            okText: this.$t('message[1597]'), // 知道了
            okType: 'primary',
            cancelText: '',
            class: 'confirm-warn-modal set-share-modal',
            onOk: async () => {}
          })
          return
        }
        this.isShare = checked
        this.permissionMenu()
      })
    }
  }
}
</script>
<style lang="scss" scoped>
  .set-share-box {
    position: relative;
    margin: 24px 0;
    padding: 16px;
    background: #FFFFFF;
    border-radius: 4px;
    border: 1px solid #E0E0E0;
    .left {
      width: 800px;
    }
    h3.title {
      font-weight: bold;
      line-height: 24px;
    }
    .right {
      position: absolute;
      top: 50%;
      right: 16px;
      margin-top: -11px;
    }
    .ant-switch {
      min-width: 40px;
      margin-right: 4px;
    }
  }
  .allocation-op-box{
    margin-bottom: 24px;
    .rule-add-box {
      float: left;
      .member-module {
        display:inline-block;
      }
    }
  }
  .allocation-table-list2 {
    margin-bottom: 40px;
  }
</style>
<style lang="scss">
.set-share-modal {
  .ant-btn-default {
    display: none;
  }
}
</style>
